<div
  [ngClass]="{ post: slide, suggest: suggest, bigger: isActive }"
  [ngStyle]="{
    'padding-left': last && 24 + 'px',
    display: slide ? 'inline-block' : 'block',
    'margin-left': slide && '24px',
    width: width + 'px',
    height: height + 'px'
  }"
>
  <div
    class="recipe-shadow"
    (click)="openRecipe(recipe?._id)"
    [ngClass]="{
      large: ratio && ratio !== '1:1',
      cover: suggest,
      'recipe-box': !suggest,
      width: width + 'px',
      height: height + 'px'
    }"
    [ngStyle]="{
      'background-image': 'url(' + image + ')',
      'background-position': 'center center',
      'background-repeat': 'no-repeat',
      width: '100%',
      height: '100%'
    }"
  >
    <div class="label" *ngIf="showLike">
      <P class="pl-5">
        {{ recipe?.likes }}
      </P>
      <img src="assets/cookingbook/heart.svg" alt="" />
    </div>
    <img
      class="play-icon"
      *ngIf="recipe?.video && showPlay"
      src="assets/cookingbook/play.svg"
      alt=""
    />

    <img
      src="assets/cookingbook/fridge-fill.svg"
      class="fridge-icon"
      *ngIf="(recipe?.kitchenInventory && showPlay) || kitchen"
      alt=""
    />
    <p class="cover-title" *ngIf="showTitle">{{ recipe?.name }}</p>
  </div>
  <p class="recipe-name" *ngIf="showName">
    {{ recipe?.name }}
  </p>
</div>
